// PL
export const listingRatesManager = {
  header: {
    eyebrow: "Stawki pochodne",
    title: "Stawki oferty",
    subtitle:
      "Scentralizuj konfigurację stawek i zastosuj ją do potrzebnych jednostek, nawet w kilku ofertach naraz, bez powtarzania tej samej pracy pojedynczo.",
    newRate: "Nowa stawka",
  },
  baseInfo: {
    title: "Ceny bazowe za noc",
    perNight: "/ noc",
    hint: "Stawki pochodne są obliczane jako korekta (% lub kwota stała) względem tych cen bazowych.",
  },
  states: {
    loading: "Wczytywanie stawek oferty...",
    emptyTitle: "Brak stawek pochodnych",
    emptyText:
      "Utwórz stawkę pochodną, aby synchronizować ceny z kanałami takimi jak Booking.com czy Airbnb.",
    createFirst: "Utwórz pierwszą stawkę",
  },
  group: {
    unitsCount: "{count} jednostka | {count} jednostki | {count} jednostek",
    manageTitle: "Zarządzaj grupą stawek",
    manage: "Zarządzaj",
    modalTitle: "Zarządzaj stawką",
    apply: "Zastosuj",
    appliedUnits: "Jednostki, w których obowiązuje",
    removeSyncedWarn:
      "Ta stawka jest połączona z kanałem. Usunięcie jej spowoduje także usunięcie jej z kanału.",
    removeConfirm: "Usunąć tę stawkę z tej jednostki?",
    removing: "Usuwanie...",
    confirmRemove: "Tak, usuń",
    removeTitle: "Usuń z tej jednostki",
    remove: "Usuń",
  },
  chips: {
    connect: "Połącz",
    paused: "Wstrzymana",
    syncedTitle: "Zsynchronizowana z kanałem",
  },
  actions: {
    editTitle: "Edytuj stawkę",
    duplicateTitle: "Duplikuj lub kopiuj",
    pause: "Wstrzymaj sprzedaż",
    resume: "Wznów sprzedaż",
    deleteTitle: "Usuń",
  },
  modal: {
    createTitle: "Nowa stawka pochodna",
    editTitle: "Edytuj stawkę",
    importPlaceholder: "Kopiuj z istniejącej stawki…",
    namePlaceholder: "Nazwa stawki",
    percentage: "% Procent",
    fixed: "Wartość stała",
    derivationHint: "Wartość ujemna obniża cenę bazową, a dodatnia ją podnosi.",
    searchPlaceholder: "Szukaj…",
    unitsCounter: "{selected} / {total} jednostek",
    selectAll: "Zaznacz wszystkie",
    deselectAll: "Wyczyść zaznaczenie",
    loadingUnits: "Wczytywanie…",
    currentBadge: "Obecna",
    unitsWithRate: "{count} jednostka ze stawką | {count} jednostki ze stawką | {count} jednostek ze stawką",
    noBaseRate: "Brak stawki bazowej",
    noResults: 'Brak wyników dla „{query}”',
    create: "Utwórz stawkę",
    creating: "Tworzenie…",
    save: "Zapisz",
    saving: "Zapisywanie…",
  },
  delete: {
    title: "Usuń stawkę pochodną",
    subtitle: "Potwierdź nazwę, aby nie usunąć stawki przez pomyłkę.",
    confirmCopy: "Wpisz nazwę stawki, aby potwierdzić:",
    deleting: "Usuwanie...",
  },
  types: {
    apartment: "Apartament",
    house: "Dom",
    villa: "Willa",
    hotel: "Hotel",
    room: "Pokój",
    studio: "Studio",
    camping: "Kemping",
    default: "Obiekt",
  },
  misc: {
    noName: "Bez nazwy",
    unitFallback: "Jednostka #{id}",
    basePrefix: "Baza:",
  },
  common: {
    cancel: "Anuluj",
    delete: "Usuń",
    close: "Zamknij",
  },
  toasts: {
    loadError: "Nie udało się wczytać stawek oferty",
    loadListingsError: "Nie udało się wczytać ofert",
    selectUnit: "Wybierz co najmniej jedną jednostkę ze stawką bazową.",
    created: "Stawka została utworzona",
    createdPartial: "Niektórych stawek nie udało się utworzyć",
    createError: "Nie udało się utworzyć stawki",
    updated: "Stawka została zaktualizowana",
    updateError: "Nie udało się zaktualizować stawki",
    updateErrorGeneric: "Błąd podczas aktualizacji stawki",
    deleted: "Stawka została usunięta",
    deleteError: "Błąd podczas usuwania",
    groupUpdated:
      "Stawka zaktualizowana w {count} jednostce | Stawka zaktualizowana w {count} jednostkach | Stawka zaktualizowana w {count} jednostkach",
    groupUpdatedPartial: "{success} zaktualizowano, {error} z błędami",
    removedFromUnit: "Stawka usunięta z tej jednostki",
    removeError: "Nie udało się usunąć stawki",
    removeErrorGeneric: "Błąd podczas usuwania stawki",
    toggleError: "Nie udało się zmienić statusu stawki",
  },
};
